import {
  TableRow,
  TableCell,
  IconButton,
  Collapse,
  Table,
  TableHead,
  TableBody,
  Grid,
} from '@material-ui/core';
import { KeyboardArrowUp, KeyboardArrowDown } from '@material-ui/icons';
import React from 'react';
import { simulationRows } from '../helpers';
import { DetailTableData } from '../interfaces';
import { createTableCellLabels } from '../TableCell/TableCellLabels';
import { createTableCellValues } from '../TableCell/TableCellValues';
import { distributionRows, getDistributionRowsByDebts } from './helpers';
import { useStyles } from './styles';

const Row: React.FC<{
  row: DetailTableData;
  isSimulation?: boolean;
}> = ({ row, isSimulation = false }) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const gridRows = isSimulation
    ? getDistributionRowsByDebts(row.debtsDistribution)
    : distributionRows;

  return (
    <React.Fragment>
      <TableRow className={classes.dividerRow} />
      <TableRow className={classes.tableRows}>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        {createTableCellValues(simulationRows, row)}
      </TableRow>
      <TableRow className={classes.tableRows}>
        <TableCell colSpan={6} variant="head" padding="none">
          <Collapse
            className={classes.collapsableContainer}
            in={open}
            timeout="auto"
            unmountOnExit
          >
            <Grid container>
              <Table size="medium">
                <TableHead className={classes.tableHeadContainer}>
                  <TableRow>{createTableCellLabels(gridRows)}</TableRow>
                </TableHead>
                <TableBody>
                  {row.EPSs.map((eps) => (
                    <TableRow key={eps.id}>
                      {createTableCellValues(gridRows, eps)}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Grid>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default Row;
